// extracted by mini-css-extract-plugin
export default {"container":"IconContainerLarge_container__YuQFw","red":"IconContainerLarge_red__QwkQJ","blue":"IconContainerLarge_blue__82FxI","green":"IconContainerLarge_green__wZKA0"};